// extracted by mini-css-extract-plugin
export var arrow = "bj_9";
export var body = "bj_c";
export var circle = "bj_fh";
export var customer = "bj_fg";
export var feedback = "bj_ff";
export var feedbacks = "bj_fc";
export var footer = "bj_cC";
export var footerText = "bj_cD";
export var left = "bj_bK";
export var nameLocation = "bj_fj";
export var padding = "bj_dt";
export var right = "bj_bY";
export var section = "bj_j";
export var selected = "bj_bg";
export var selectors = "bj_fb";
export var subtitle = "bj_cR";
export var text = "bj_ck";
export var title = "bj_g";
export var wrapper = "bj_fd";